<template>
    <div class="layout-container-box">
        <el-header class="layout-header">
            <Header>
                <template #header-brand>
                    <BreadCrumb :breadList="breadLists" />
                </template>
            </Header>
        </el-header>
        <el-scrollbar class="layout-main-content" id="content_box">
            <div class="pd-20">
                <div class="create-person-container" id="literature">
                    <el-card class="mg-b-16">
                        <template #header>
                            <div class="card-header">
                                <span class="card-name">表单基本信息</span>
                            </div>
                        </template>
                        <div class="form_name">
                            <el-form ref="formRef" :model="articeForm"  label-width="140px"
                                class="user-form-box">
                                <el-form-item label="表单名称：" prop="title">
                                    <el-input style="width: 400px" v-model="articeForm.title" placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="截止时间：" prop="register_end_time">
                                    <el-date-picker style="width: 150px" type="date" v-model="articeForm.register_end_time"
                                        placeholder="选择日期" value-format="YYYY-MM-DD">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="banner上架：" prop="date">
                                    <el-radio-group v-model="articeForm.is_banner" class="ml-4">
                                        <el-radio label="2" size="large">是</el-radio>
                                        <el-radio label="1" size="large">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="头图：" prop="image" >
                                    <p>限制大小1M,支持JPG、PNG格式</p>
                                    <el-upload class="avatar-uploader" :class="{
                                        border: !articeForm.image,
                                    }" :show-file-list="false" action="#" :http-request="(file) => {
                                        return uploadImage(file, 'image')
                                    }" accept="image/jpg, image/jpeg, image/png" :before-upload="beforeUpload">
                                        <div class="avatar-img-box" v-if="articeForm.image">
                                            <img :src="articeForm.image" class="avatar" />
                                        </div>
                                        <el-icon v-else class="avatar-uploader-icon">
                                            <plus />
                                        </el-icon>
                                    </el-upload>
                                </el-form-item>
                                <!-- <el-form-item label="公司名称：" prop="title">
                                    <el-input style="width: 400px" v-model="articeForm.company" placeholder="请输入"></el-input>
                                </el-form-item> -->
                            </el-form>
                        </div>
                    </el-card>
                    <el-card class="mg-b-16">
                        <template #header>
                            <div class="create_con_box">
                                <div class="card-header">
                                    <span class="card-name">表单内容</span>
                                </div>
                            </div>
                        </template>
                        <div class="form_model_box">
                            <div class="type_box">
                                <div class="type_item" v-for="item in typeList" :key="item.value" @click="addFormItem(item)">{{ item.label }}</div>
                            </div>
                            <el-scrollbar height="600px" class="form_scroll_box">
                            <div class="form_box">
                                <el-form ref="formRef" label-width="100px" 
                                    class="model_form">
                                    <template v-for="(item,formIndex) in formList">
                                        <!-- :models.sync="models" -->
                                        <div :class="['form_border_box',activeIndex==formIndex?'form_item_active':'']" @click="onInputChange(item,formIndex)">
                                            <GenetateFormItem :data="item" ></GenetateFormItem>
                                            <div class="widget-view-action">
                                                <div class="handel_box" @click="copyItem(item)"><el-icon><CopyDocument /></el-icon></div>
                                                <div class="handel_box" @click="deleteItem(formIndex)"><el-icon><Delete /></el-icon></div>
                                            </div>
                                        </div>
                                    </template>
                                </el-form>
                                <div class="tip" v-if="formList.length==0">左侧点击添加字段</div>
                            </div>
                        </el-scrollbar>
                            <el-scrollbar height="600px" v-if="formList.length>0">
                            <div class="control_box">
                                <ui class="control_group">
                                    <!-- <li class="control_item">
                                        <div class="el-form-item__label from_label">字段标识（id）</div>
                                        <el-input style="width: 300px" v-model="targeItme.id"></el-input>
                                    </li> -->
                                    <li class="control_item" v-if="targeItme.type==7">
                                        <div class="el-form-item__label from_label">纯标题</div>
                                        <el-input style="width: 300px" v-model="targeItme.value"></el-input>
                                    </li>
                                    <li class="control_item" v-if="targeItme.type!=7  && targeItme.type!=12">
                                        <div class="el-form-item__label from_label">标题</div>
                                        <el-input style="width: 300px" v-model="targeItme.label"></el-input>
                                    </li>
                                    <li class="control_item" v-if="targeItme.type!=2 && targeItme.type!=7  && targeItme.type!=12  && targeItme.type!=11 & targeItme.type!=9">
                                        <div class="el-form-item__label from_label">提示内容</div>
                                        <el-input style="width: 300px" v-model="targeItme.placeholder"></el-input>
                                    </li>
                                    <li class="control_item" v-if="targeItme.type==2 || targeItme.type==3 || targeItme.type==4">
                                        <div class="el-form-item__label from_label">选项</div>
                                        <div class="">
                                            <div class="option_item" v-for="(item,index) in targeItme.option">
                                                <el-input v-model="item.label" placeholder="请输入" size="small"></el-input>
                                                
                                                <el-button type="primary" @click="deleteOption(targeItme.option,index)" size="small"> <el-icon><Delete /></el-icon> </el-button>
                                            </div>
                                            <el-button type="primary" @click="addOption(targeItme.option)" size="small">添加</el-button>
                                        </div>
                                    </li>

                                    <li class="control_item" v-if="targeItme.type==5">
                                        <div class="el-form-item__label from_label">选项</div>
                                        <div class="">
                                            <div class="option_item more_select_item" v-for="(item,index) in targeItme.option">
                                                <div class="levelone_box">
                                                    <div class="one_box">
                                                        <el-input v-model="item.label" placeholder="请输入" size="small"></el-input>
                                                        <el-button type="primary" @click="deleteOption(targeItme.option,index)" size="small"> <el-icon><Delete /></el-icon> </el-button>
                                                    </div>
                                                </div>
                                                <div class="leventwo_box" >
                                                    <div class="two_box" v-for="(cell,idx) in item.children">
                                                        <el-input v-model="cell.label" placeholder="请输入" size="small"></el-input>
                                                        <el-button type="primary" @click="deleteMore(item.children,idx)" size="small"> <el-icon><Delete /></el-icon> </el-button>
                                                    </div>
                                                    <el-button type="primary" @click="addMoreTwo(item.children)" size="small">添加</el-button>
                                                </div>
                                            </div>
                                            <el-button type="primary" @click="addMoreOne(targeItme.option)" size="small">添加</el-button>
                                        </div>
                                    </li>


                                    <li class="control_item" v-if="targeItme.type!=7 && targeItme.type!=12">
                                        <div class="el-form-item__label from_label">是否必填</div>
                                        <el-radio-group v-model="targeItme.must" class="ml-4">
                                            <el-radio label="1" size="large">是</el-radio>
                                            <el-radio label="2" size="large">否</el-radio>
                                        </el-radio-group>
                                    </li>
                                    <li class="control_item" v-if="targeItme.type==8">
                                        <div class="el-form-item__label from_label">是否当做文字展示</div>
                                        <el-radio-group v-model="targeItme.isshow" class="ml-4">
                                            <el-radio label="1" size="large">是</el-radio>
                                            <el-radio label="2" size="large">否</el-radio>
                                        </el-radio-group>
                                    </li>
                                </ui>
                            </div>
                        </el-scrollbar>
                        </div>

                        <div class="btn_box">
                            <el-button @click="cancle">取消</el-button>
                            <el-button @click="resetForm">重置</el-button>
                            <el-button type="primary" @click="saveData">保存</el-button>
                        </div>
                    </el-card>
                </div>
            </div>
            
        </el-scrollbar>
        
    </div>
</template>
  
<script>
import { ref, onMounted } from "vue";

import { Ajax, MessageTips } from "../../../utils";
import { Plus, CopyDocument,Delete } from "@element-plus/icons-vue";
import MenuTrees from "../../../components/MenuTrees/MenuTrees.vue";
import CheckTag from "../../../components/CheckTag";
import Header from "../../../Layout/components/Header.vue";
import BreadCrumb from "../../../components/BreadCrumb/index.vue";
import tinymceEditor from '@/components/tinymceEditor/index.vue'
import GenetateFormItem from './GenerateFormItem.vue'
import { useRouter, useRoute } from "vue-router";

import { nanoid } from 'nanoid'
export default {
    components: {
        Plus,
        MenuTrees,
        CheckTag,
        Header,
        BreadCrumb,
        tinymceEditor,
        GenetateFormItem,
        CopyDocument,
        Delete
    },
    setup() {
        const router = useRouter();
        const route = useRoute()
        const breadLists = ref([
            {
                name: "表单",
                path: {
                    name: "Form",
                },
            },
            {
                name: "创建表单",
            },
        ]);
        const articeForm = ref({
            title:"",
            register_end_time:"",
            is_banner:"1",
            image:"",
            company:"",
        })
        const typeList = ref([
            {type:1,label:"短文本框",id:nanoid(8),value:"",placeholder:"",must:"2"},
            {type:2,label:"多选",id:nanoid(8),value:"",placeholder:"",must:"2",option:[{value:1,label:"选项一"}]},
            {type:3,label:"下拉菜单",id:nanoid(8),value:"",placeholder:"",must:"2",option:[{value:1,label:"选项一"}]},
            {type:4,label:"单选",id:nanoid(8),value:"",placeholder:"",must:"2",option:[{value:1,label:"选项一"}]},
            {type:5,label:"多级下拉",id:nanoid(8),value:"",placeholder:"",must:"2",option:[{value:1,label:"选项一",children:[{value:`0${1}`,label:"选项A"}]}]},
            {type:6,label:"日期",id:nanoid(8),value:"",placeholder:"",must:"2"},
            {type:7,label:"纯标题",id:nanoid(8),value:"",placeholder:"",must:"2"},
            {type:8,label:"长文本框",id:nanoid(8),value:"",placeholder:"",must:"2",isshow:'2'},
            {type:9,label:"省市级连",id:nanoid(8),value:"",placeholder:"",must:"2"},
            {type:10,label:"数字框",id:nanoid(8),value:"",placeholder:"",must:"2"},
            {type:11,label:"上传图片",id:nanoid(8),value:"",placeholder:"",must:"2"},
            {type:12,label:"分割线",id:nanoid(8),value:"",placeholder:"",must:"2"},
            {type:13,label:"上传文件",id:nanoid(8),value:"",placeholder:"",must:"2"},
        ])
        // const dialogVisible = ref(true)
        const formItem = ref({
            id:1,
            type:null,
            title:'',
        })
        const targeItme=ref({})//目标字段
        const formList=ref([])
        const activeIndex=ref(0)
        //点击添加表单项
        const addFormItem = (value)=>{
            formList.value.push( JSON.parse(JSON.stringify(value)))
            targeItme.value = formList.value[formList.value.length-1]
            activeIndex.value = formList.value.length-1
        }
        //复制
        const copyItem = (value)=>{
            value.id = nanoid(8)
            let copyObj = JSON.parse(JSON.stringify(value))
            delete copyObj.id
            copyObj.id = nanoid(8)
            formList.value.push(copyObj)
        }
        //删除
        const deleteItem = (index) =>{
            formList.value.splice(index,1)
        }
        //点击表单项
        const onInputChange = (value,index)=>{
            targeItme.value = value
            activeIndex.value = index
        }
        //添加选项
        const addOption = (data)=>{
            if(data.length>0){
                let num = JSON.parse(JSON.stringify(data[data.length-1].value))
                let newOption = {
                    value:num+=1,
                    label:"新选项"
                }
                data.push(newOption)
            }else{
                data.push({
                    value:1,
                    label:"新选项"
                })
            }
        }
        
        //添加多级下拉第一级
        const addMoreOne = (data)=>{
            
            if(data.length>0){
                let num = JSON.parse(JSON.stringify(data[data.length-1].value))
                let newOption = {
                    value:num+=1,
                    label:"新一级选项",
                    children:[
                        {value:'01',label:"新二级选项"},
                    ]
                }
                data.push(newOption)
            }else{
                data.push({
                    value:1,
                    label:"新一级选项",
                    children:[
                        {value:'01',label:"新二级选项"},
                    ]
                })
            }
        }
        //添加多级下拉二级
        const addMoreTwo = (data)=>{
            
            if(data.length>0){
                let num =JSON.parse(JSON.stringify(data[data.length-1].value));
                num = Number(num)

                let newOption = {
                    value:`0${num+=1}`,
                    label:"新二级选项",
                }
                data.push(newOption)
            }
        }

        //删除选项
        const  deleteOption = (data,index)=>{
            if(data.length>1){
                data.splice(index,1)
            }else{
                MessageTips.warning("至少需要保留一个选项");
            }
        }
        //删除二级选项 
        const deleteMore = (data,index) =>{
            if(data.length>1){
                data.splice(index,1)
            }else{
                MessageTips.warning("至少需要保留一个选项");
            }
        }

        //取消创建
        const cancle=()=>{

        }
        //重置表单
        const resetForm=()=>{
            formList.value=[]
        }
        //保存表单
        const saveData=()=>{
            if(articeForm.value.is_banner==2 && articeForm.value.image==''){
                MessageTips.error('请上传banner图');
                return false
            }
            if(formList.value.length==0){
                MessageTips.error('请填充表单');
                return false
            }
            let params = articeForm.value;
            params.content = JSON.stringify(formList.value)

            let url='';
            if(route.query.id){
                url=`/admin/form/update/${route.query.id}`
            }else{
                url='/admin/form/create'
            }
            Ajax.POST({
                url:url,
                data: params
                
            }).then((res) => {
                if (res.data.code == 200) {
                    MessageTips.success(route.query.id?"编辑成功":"创建成功");
                    router.back();
                } else {
                    MessageTips.error(res.data.msg);
                }
            });
        }

        // 限制文件大小
        const beforeUpload = (file) => {
            const isL1M = file.size / 1000 / 1000 <= 1;
            if (!isL1M) {
                MessageTips.error("文件上传不能大于1M");
                return false;
            }
            return true;
        };
        const uploadImage = (data, target) => {
            const file = data.file;
            let formData = new FormData();
            formData.append("image", file);
            formData.append("restrict", "1000");
            Ajax.POST({
                url: "/admin/upload/image",
                contentType: "multipart/form-data",
                data: formData,
            }).then((res) => {
                if (res.data.code === 200) {
                    articeForm.value[target] = res.data.data.url;
                } else {
                    MessageTips.error(res.data.msg);
                }
            });
        };
        //获取表单详情
        const getData =async ()=>{
            const res = await Ajax.POST({
                url: "/admin/form/detail/" + route.query.id,
            });
            if (res.data.code === 200){
                articeForm.value = res.data.data
                formList.value=res.data.data.content
                articeForm.value.is_banner=res.data.data.is_banner.toString()
                targeItme.value = res.data.data.content[0]
                activeIndex.value = 0
            }
        }
        onMounted(() => { 
            if(route.query.id){
                getData()
                breadLists.value[1].name="编辑表单"
            }
        });
        return {
            breadLists,
            articeForm,
            // dialogVisible,
            formItem,
            typeList,
            formList,//表单渲染器
            addFormItem,
            targeItme,
            onInputChange,
            addOption,
            addMoreOne,
            addMoreTwo,
            deleteOption,
            deleteMore,
            activeIndex,
            copyItem,
            deleteItem,
            cancle,
            resetForm,
            saveData,
            uploadImage,
            beforeUpload,
        };
    },
};
</script>
  
<style lang="less" scoped>
.form_model_box{
    display: flex;
    min-height: 200px;
    .type_box{
        width: 200px;
        display: flex;
        flex-wrap: wrap;
        max-height: 180px;
        .type_item{
            // display: block;
            width: 90px;
            height: 40px;
            line-height: 40px;
            cursor: pointer;
            background: #f4f6fc;
            border: 1px solid #f4f6fc;
            font-size: 12px;
            padding: 0px 8px;
            border-radius: 4px;
            margin-right: 10px;
            text-align: center;
            margin-bottom: 10px;
        }
    }
    .form_scroll_box{
        max-width:500px;
    }
    // .avatar-img-box {
    //     width: 108px;
    //     height: 108px;

    //     .avatar {
    //         width: 100%;
    //         height: 100%;
    //         object-fit: cover;
    //     }
    // }
    
    .form_box{
        width: 40%;
        min-width:480px;
        min-height: 200px;
        border: 1px dashed #999;
        padding-right:10px;
        .tip{
            width: 100%;
            text-align: center;
            color: #ccc;
            font-size: 20px;
            margin-top:80px;
        }
        .widget-view-action{
            display: none;
        }
        .form_border_box{
            margin-top: 3px;
            &:hover{
                background-color: #ecf5ff;
                outline: 1px solid #409EFF;
                border: 1px solid #409EFF;
            }
        }
        .form_item_active{
            outline: 2px solid #409EFF;
            border: 1px solid #409EFF;
            position: relative;
            &:hover{
                background-color: #ecf5ff;
            }
            .widget-view-action{
                display: block;
                position: absolute;
                right: 0;
                bottom: 0;
                height: 28px;
                line-height: 28px;
                background: #409EFF;
                z-index: 9;
                width: 70px;
                display: flex;
                .handel_box{
                margin-left: 5px;
                padding: 0 8px;
                color: #fff;
                cursor: pointer;
                &:first-child{
                    margin-left: 0px;
                }
                }
            }
        }

    }
    .control_box{
        width: 300px;
        margin-left: 10px;
        min-height: 300px;
        
        
        .control_group{
            list-style: none;
            .label{

            }
            .control_item{
                width: 100%;
                margin-bottom: 10px;
                border-bottom: 1px solid #999;
                padding-bottom: 10px;
                .from_label{
                    text-align: left;
                }
                .option_item{
                    display: flex;
                    margin-bottom: 5px;
                    .levelone_box{
                        margin-right: 5px;
                        .one_box{
                            display: flex;
                            margin-bottom: 5px;
                        }
                        // display: flex;
                        // flex-direction: column;
                    }
                    .leventwo_box{
                        .two_box{
                            display: flex;
                            margin-bottom: 5px;
                        }
                        // display: flex;
                        // flex-direction: column;
                    }

                }
                .more_select_item{
                    border-bottom: 1px solid #999;
                    padding-bottom: 5px;
                    margin-bottom: 5px;
                }
            }
        }
    }
    
    .model_form{
        // border: 1px solid #ddd;
    }
}
.create-person-container {
    height: 100%;

    .write-box {
        background-color: #fff;
    }

    .user-form-box {
        width: 80%;

        // padding: 0px 180px;
        .info-img {
            width: 200px;
            height: 200px;
        }
    }

    .bottom-submit-box {
        background-color: #fff;
    }

    .form-container {
        height: 100%;
        overflow: auto;
    }
}

.create_con_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.btn_box{
    text-align:right
}
:deep(.avatar-uploader) {
        font-size: 28px;
        color: #8c939d;
        width: 108px;
        height: 108px;
        line-height: 108px;
        text-align: center;
        border:1px solid #ddd
    }
    :deep(.avatar-img-box) {
        width: 108px;
        height: 108px;
        .avatar{
            width: 108px;
            height: 108px;
        }
    }
</style>